import type { JobOffer } from '~/business/JobOffer/types';

// a French or Italian postal code starts with its department or province; a US ZIP code says nothing readable
export const getAreaCode = (country: string, { postalCode, state }: JobOffer['location']): string | undefined =>
  country === 'US' ? state : postalCode?.slice(0, 2);
